import { render } from "./ProductBranchEdit.vue?vue&type=template&id=45195108&ts=true"
import script from "./ProductBranchEdit.vue?vue&type=script&lang=ts"
export * from "./ProductBranchEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__